import { ButtonProps } from '@mui/material';
import clsx from 'clsx';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import Button, { ButtonModel } from 'src/legacy/components/Button';
import BaseTypography from 'src/legacy/components/Text/BaseTypography';
import * as Colors from 'src/theme/colors';
import { PrimaryButtonShadow } from 'src/theme/shadows';

const useStyles = makeStyles()(() => ({
  root: {
    boxShadow: PrimaryButtonShadow,
    borderRadius: 4,
    border: `1px solid ${Colors.NonHoverBlackBorder}`,
  },
  containedBackground: {
    background: Colors.BlackHeadings,
    transition: 'opacity 100ms ease',
    '&:hover': {
      opacity: '0.9',
    },
    '&:disabled': {
      background: Colors.BlackHeadings,
    },
  },
  submitButton: {
    height: 48,
    width: '100%',
  },
  sharpButton: {
    borderRadius: 0,
    borderColor: Colors.HoverBorder,
  },
}));

const OnboardingButton: React.FC<ButtonProps & ButtonModel> = ({
  children,
  ...otherProps
}) => {
  const { classes } = useStyles();

  return (
    <Button
      className={clsx(
        classes.root,
        classes.submitButton,
        classes.sharpButton,
        // add custom backgrounds for mui-buttons where variant is contained
        { [classes.containedBackground]: otherProps.variant === 'contained' },
      )}
      {...otherProps}
    >
      <BaseTypography fontType="15Medium">{children}</BaseTypography>
    </Button>
  );
};

export default OnboardingButton;
